// ============================================================
// THE LENS ON THE PANEL'S CAMERA - what the camera should wear, whoever set
// it last (plan map-display, C; the review of Track C).
//
//   - The classic map: no lens and no lift, ever - a shot left on the camera
//     (over the shoulder's 60, a lifted look-at) must not survive a switch.
//   - The display, held by the viewer (or with nothing framed yet): the
//     viewer's lens - and again after a Reset or a preset refits it flat.
//   - The display, following a shot: the shot's own lens (over the shoulder
//     is wider on purpose); nothing to correct.
//
// Pure. Zero React dependency.
// ============================================================
import type { Camera } from '../battlefield/projection';

const fovOf = (fov: number | undefined) => fov || undefined;

function flat(camera: Camera): Camera {
  const { fov: _fov, lift: _lift, ...rest } = camera;
  return rest;
}

function withLens(camera: Camera, fov: number | undefined): Camera {
  const { fov: _fov, ...rest } = camera;
  return fov ? { ...rest, fov } : rest;
}

/**
 * The camera as it should be worn: the same object when nothing is wrong, so
 * a caller can compare by identity and write only on a change.
 */
export function lensFor(camera: Camera, display: boolean, lens: number | undefined, shotOwnsIt: boolean): Camera {
  if (!display) return camera.fov || camera.lift ? flat(camera) : camera;
  if (shotOwnsIt || fovOf(camera.fov) === fovOf(lens)) return camera;
  return withLens(camera, lens);
}
